import React from 'react';
import PropTypes from 'prop-types';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import RadarList from 'components/Radar/List';
import { useQueryString } from 'helpers/effects';

const ScreenRadarList = ({ routePaths, target, titleKey }) => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <RadarList
          initialFilters={initialFilters}
          routePaths={routePaths}
          target={target}
          titleKey={titleKey}
        />
      </GridItem>
    </GridContainer>
  );
};

ScreenRadarList.propTypes = {
  routePaths: PropTypes.shape({}),
  target: PropTypes.string,
  titleKey: PropTypes.string,
};

ScreenRadarList.defaultProps = {
  routePaths: undefined,
  target: undefined,
  titleKey: undefined,
};

export default ScreenRadarList;
